import { render, staticRenderFns } from "./UnauthorizedPage.vue?vue&type=template&id=471d32ee&scoped=true"
import script from "./UnauthorizedPage.vue?vue&type=script&lang=js"
export * from "./UnauthorizedPage.vue?vue&type=script&lang=js"
import style0 from "./UnauthorizedPage.vue?vue&type=style&index=0&id=471d32ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471d32ee",
  null
  
)

export default component.exports